import { Animation, AnimationConfig } from './types';

export class TubeAnimation2D implements Animation {
  private ctx: CanvasRenderingContext2D;
  private canvas: HTMLCanvasElement;
  private lastTime: number = Date.now();
  private offset: number = 0;
  private size: number;

  constructor({ canvas, size }: AnimationConfig) {
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      throw new Error('Failed to get 2D context');
    }
    this.ctx = ctx;
    this.canvas = canvas;
    this.size = size;
  }

  update(): void {
    const now = Date.now();
    const dt = (now - this.lastTime) / 1000;
    this.offset += dt * 20;
    this.lastTime = now;

    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    this.drawSineWave(this.offset);
    this.drawSineWave(this.offset + Math.PI);
  }

  private drawSineWave(offset: number) {
    this.ctx.beginPath();
    this.ctx.moveTo(0, this.canvas.height / 2);

    for (let x = 0; x < this.canvas.width; x++) {
      const y =
        this.canvas.height / 2 + (Math.sin(x * 0.05 + offset) * this.size) / 2;
      this.ctx.lineTo(x, y);
    }

    this.ctx.strokeStyle = 'rgba(255, 255, 255, 0.8)';
    this.ctx.lineWidth = 4;
    this.ctx.stroke();
  }

  cleanup(): void {}
}
